// @flow
import type { Checker } from './validation/runtime-checks/index.js';
import { types as t } from './validation/runtime-checks/index.js';
import Latex from './Latex.js';
import { LatexTextAtom } from './LatexTextAtom.js';

// Components that are designed for use within the editor need to have
// an associated spec. The spec ensures we can provide validation/usage
// assistance to writers in the editor. An example of how we write these
// components:
//
// function Text() { ... }
// Text.spec = { children: t.string }
//
// ComponentWithSpecification is used to describe this type of component.
type ComponentWithSpecification<Config> = React$ComponentType<Config> &
  React$AbstractComponentStatics & { spec: { [prop: string]: Checker } };

export type { ComponentWithSpecification };

export const mathStringChecker = t.unionOfTypes(
  t.string,
  t.elementType(Latex),
  t.elementType(LatexTextAtom),
);

export type MathString =
  | string
  | React$Element<typeof Latex>
  | React$Element<typeof LatexTextAtom>;
